import WholeApi from "@/components/Api/wholeApi";
export const UploadMinxin = {
  props: {
    // 值
    value: [String, Object, Array],
    // oss路径
    ossRoute: {
      type: String,
      default: () => {
        return "";
      },
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    //点击是继续上传 按钮 触发其它事件
    isSpread: {
      type: Boolean,
      default: false,
    },
    // 文件类型, 例如["doc", "xls", "ppt", "txt", "pdf"]
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    // 文件列表类型 text/picture/picture-card
    listType: {
      type: String,
      default: "picture",
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
    // 最大允许上传个数
    fileLimit: {
      type: Number,
      default: 99,
    },
    parentId: {
      type: String,
      default: () => {
        return "0";
      },
    },
    ossPath: {
      type: String,
      default: () => {
        return "user";
      },
    },
    flodName: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      paramsData: {
        Authorization: "Bearer token",
        output: "json",
      }, // 上传携带的参数，看需求要不要
      fileList: [],
      tempFileList: [], // 因为 fileList为只读属性，所以用了一个中间变量来进行数据改变的交互。
    };
  },
  watch: {
    value: {
      handler(newVal, oldVa) {
        this.tempFileList = newVal;
        this.dataFusion();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
    fileTypeName() {
      let typeName = "";
      this.fileType.forEach((item) => {
        typeName += `${item}，`;
      });
      return typeName;
    },
    fileAccept() {
      let fileAccept = "";
      this.fileType.forEach((element) => {
        fileAccept += `.${element},`;
      });
      return fileAccept;
    },
  },
  created() {
    if (this.value) {
      this.fileList = JSON.parse(JSON.stringify(this.value));
    }
  },
  methods: {
    queryPics(id) {
      if (this.parentId != 0 || id) {
        let parentId = id ? id : this.parentId;
        let arr;
        if (this.flodName) {
          arr = [parentId, "&" + this.flodName];
        } else {
          arr = [parentId];
        }
        new WholeApi(this.ossPath)
          .factoryApi()
          .queryPicByParentIds(arr)
          .then((res) => {
            if (res.status === 200) {
              this.changeFileList(res.data);
            }
          });
      }
    },
    deletePicData(picId) {
      return new Promise((resolve, reject) => {
        if (picId && picId > 0) {
          new WholeApi(this.ossPath)
            .factoryApi()
            .delFile(picId)
            .then((res) => {
              if (res.status === 200) {
                this.changeFileList(this.$refs["upload"].uploadFiles);
                resolve(true);
              }
            });
        }
      });
    },
    blobToDataURL(blob, callback) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", blob); // blob:http://localhost:8080/da126298-1b6b-4dfb-8a92-2e3ccbee611d
      xhr.responseType = "blob";
      xhr.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          const imageBlob = this.response;
          console.log("asdad", imageBlob);
        }
      };
    },
    handlePictureCardPreview(e) {
      this.pointIndex = e.flodName;
      let picList = this.$refs["upload"].uploadFiles;
      picList.forEach((item) => {
        if (item.url.indexOf("blob:") !== -1) {
          console.log(item.url);
        }
      });
      this.init(picList);
      this.checkedPic = 0;
      this.dataFusion();
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType && file) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk & file) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize && file) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`超出上传文件个数,请删除以后再上传！`);
    },
    // 文件上传成功的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success("上传成功");
      this.changeFileList(fileList);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      console.log("文件列表", fileList, file);
      if (file.id) {
        this.deletePicData(file.id).then((res) => {
          if (res) {
            fileList = fileList.filter((n) => n.id !== file.id);
            this.changeFileList(fileList);
          }
        });
      } else {
        fileList = fileList.filter((n) => n.uid !== file.uid);
        this.changeFileList(fileList);
      }
    },
    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    fileListChange(file, fileList) {
      console.log(
        "文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用",
        file,
        fileList
      );
      this.changeFileList(fileList);
    },
    // 文件列表改变的时候，更新组件的v-model的文的数据
    changeFileList(fileList) {
      const tempFileList = fileList.map((item) => {
        let tempItem = {
          id: item.id,
          name: item.name,
          // flodName: item.flodName === '' ? this.flodName : item.flodName,
          flodName: item.flodName ? item.flodName : this.flodName,
          url: item.response ? item.response.url : item.url,
        };
        return tempItem;
      });
      this.fileList = tempFileList;
      this.$emit("input", tempFileList);
    },
    // 文件列表
    manualUpload(fileList, linkId) {
      return new Promise((resovle, reject) => {
        console.log("将要上传的文件", fileList, this.ossPath);
        let _that = this;
        fileList
          .filter((x) => x.url.indexOf("blob:") !== -1)
          .forEach((item) => {
            const xhr = new XMLHttpRequest();
            xhr.open("GET", item.url); // blob:http://localhost:8080/da126298-1b6b-4dfb-8a92-2e3ccbee611d
            xhr.responseType = "blob";
            xhr.onreadystatechange = function () {
              if (this.readyState === 4 && this.status === 200) {
                const imageBlob = this.response;
                const imageType = imageBlob.type;
                // 上传 Blob 图片
                const form = new FormData();
                form.append("file", imageBlob, item.name); // 第三个参数为文件名
                form.append("parentId", linkId);
                form.append("flodName", item.flodName);
                form.append("ossPath", _that.ossRoute);
                console.log("将要上传的文件11", form, _that.ossPath);
                new WholeApi(_that.ossPath)
                  .factoryApi()
                  .uploadSingle(form)
                  .then((res) => {
                    if (res.status === 200) {
                      resovle(res.data);
                    }
                  });
              }
            };
            xhr.send();
          });
      });
    },
  },
  mounted() {
    setTimeout(() => {
      this.queryPics();
    },500);
  },
};
